module.exports = __webpack_public_path__ + "static/media/asus.cacd1899.png";